import {
  MEDIA_DIRECTORY_GET_ROOT,
  MEDIA_DIRECTORY_GET_ROOT_SUCCESS,
  MEDIA_DIRECTORY_GET_ROOT_ERROR,
  MEDIA_DIRECTORY_GET,
  MEDIA_DIRECTORY_GET_SUCCESS,
  MEDIA_DIRECTORY_GET_ERROR,
  MEDIA_DIRECTORY_ADD_VIDEO,
} from './type'

/**
 *
 */
export const mediaDirectoryGetRoot = (page, filterText, filterType) => {
  return {
    type: MEDIA_DIRECTORY_GET_ROOT,
    payload: { page, filterText, filterType },
  }
}

/**
 *
 * @param {*} entity
 */
export const mediaDirectoryGetRootSuccess = entity => {
  return {
    type: MEDIA_DIRECTORY_GET_ROOT_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const mediaDirectoryGetRootError = () => {
  return {
    type: MEDIA_DIRECTORY_GET_ROOT_ERROR,
  }
}

/**
 *
 * @param {*} id
 */
export const mediaDirectoryGet = request => {
  return {
    type: MEDIA_DIRECTORY_GET,
    payload: { request },
  }
}

/**
 *
 * @param {*} entity
 */
export const mediaDirectoryGetSuccess = entity => {
  return {
    type: MEDIA_DIRECTORY_GET_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const mediaDirectoryGetError = () => {
  return {
    type: MEDIA_DIRECTORY_GET_ERROR,
  }
}

/**
 * Add a newly uploaded video to the directory
 * @param {*} videoDetails - Video details from upload completion
 */
export const mediaDirectoryAddVideo = videoDetails => {
  return {
    type: MEDIA_DIRECTORY_ADD_VIDEO,
    payload: { videoDetails },
  }
}
